import { render, staticRenderFns } from "./Ranks.vue?vue&type=template&id=15ea6f23&scoped=true"
import script from "./Ranks.vue?vue&type=script&lang=ts"
export * from "./Ranks.vue?vue&type=script&lang=ts"
import style0 from "./Ranks.vue?vue&type=style&index=0&id=15ea6f23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ea6f23",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BtnDirection: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/btn-direction.vue').default})
